

































































































import { Component, Vue } from 'vue-property-decorator'
import axiosInstance from '@/plugins/axios'
import { showHttpErrorAlert } from '@/plugins/helper'
import AppNavDrawer from '@/components/AppNavDrawer.vue'

@Component({
  components: {
    AppNavDrawer
  }
})
export default class PageViewHospitals extends Vue {
  headers = [
    { text: 'ID', value: 'id' },
    { text: 'Region', value: 'region' },
    { text: 'English name', value: 'nameEn' },
    { text: 'Lao name', value: 'nameLa' },
    { text: 'Tel', value: 'tel' },
    { text: 'Image', value: 'coverImage' },
    { text: 'Created At', value: 'createdAt' },
    { text: 'Active at', value: 'activeAt' }
    // { text: '', value: 'action' }
  ]

  items = []
  showAddDialog = false
  activeItem: any = {}
  isAdding = false
  isLoadingItems = false

  created () {
    this.fetchHospitals()
  }

  async fetchHospitals () {
    try {
      this.isLoadingItems = true
      const { data } = await axiosInstance.get('/portal/insurance/hospitals')
      this.items = data.data.map((item: any) => {
        return {
          id: item.id,
          region: item.region,
          nameEn: item.name_en,
          nameLa: item.name_la,
          tel: item.tel,
          latitude: item.latitude,
          longitude: item.longitude,
          coverImage: item.cover_image,
          addressEn: item.address_en,
          addressLa: item.address_la,
          createdAt: item.created_at,
          activeAt: item.active_at
        }
      })
      this.isLoadingItems = false
    } catch (error) {
      this.isLoadingItems = false
      showHttpErrorAlert(error)
    }
  }

  async handleAddForm () {
    try {
      this.isAdding = true
      await axiosInstance.post('/portal/insurance/hospitals', {
        'region': this.activeItem.region,
        'name_en': this.activeItem.nameEn,
        'name_la': this.activeItem.nameLa,
        'tel': this.activeItem.tel,
        'latitude': null,
        'longitude': null,
        'cover_image': null,
        'address_en': null,
        'address_la': null,
        'created_at': this.activeItem.createdAt,
        'active_at': this.activeItem.activeAt
      })

      this.isAdding = false
      this.showAddDialog = false
      this.fetchHospitals()
    } catch (error) {
      this.isAdding = false
      showHttpErrorAlert(error)
    }
  }
}
